import { render } from "./PasswordReset.vue?vue&type=template&id=c9e0a06a"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PasswordReset.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_73d03741%2Fpackages%2Fcustomer%2Fsrc%2Fviews%2FPasswordReset.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__